(function() {
    'use strict';

    class MrCompanyService {
        constructor($q, $http, MR_COMPANY_SERVICE_URL){
            this.$q = $q;
            this.$http = $http;
            this.MR_COMPANY_SERVICE_URL = MR_COMPANY_SERVICE_URL;
        }

        setAcceptedTerms() {
            let deferred = this.$q.defer();

            this.$http
                .put(
                    this.MR_COMPANY_SERVICE_URL + '/overrides',
                    {
                        'name': 'mrShowUpdatedTerms0923',
                        'value': false
                    }
                )
                .finally(() => {
                    // ignoring errors to set accepted terms. worst case they need to accept them again. if this becomes problematic we can revisit.
                    deferred.resolve();
                });

           return deferred.promise;
        }
    }

    angular
        .module('MW.Influencers.MrCompanyService', [
            'MW.Configuration',
        ])
        .service('MrCompanyService', [
            '$q',
            '$http',
            'MR_COMPANY_SERVICE_URL',
            MrCompanyService
        ]);
})();